import SvgAreas from "../../../../components/main/wrappers/svg-areas/SvgAreas";
import SvgCustoms from "../../../../components/main/wrappers/svg-customs/SvgCustoms";

import { ReactComponent as Church_2_1 } from "../../../../static/images/contents/zone-3/icons/2/church_1.svg";
import { ReactComponent as Church_2_2 } from "../../../../static/images/contents/zone-3/icons/2/church_2.svg";
import { ReactComponent as Church_2_3 } from "../../../../static/images/contents/zone-3/icons/2/church_3.svg";
import { ReactComponent as Church_2_4 } from "../../../../static/images/contents/zone-3/icons/2/church_4.svg";
import { ReactComponent as Church_2_5 } from "../../../../static/images/contents/zone-3/icons/2/church_5.svg";
import { ReactComponent as Church_2_6 } from "../../../../static/images/contents/zone-3/icons/2/church_6.svg";
import { ReactComponent as Church_2_7 } from "../../../../static/images/contents/zone-3/icons/2/church_7.svg";
import { ReactComponent as Church_2_8 } from "../../../../static/images/contents/zone-3/icons/2/church_8.svg";
import { ReactComponent as School_2_1 } from "../../../../static/images/contents/zone-3/icons/2/school_1.svg";
import { ReactComponent as School_2_2 } from "../../../../static/images/contents/zone-3/icons/2/school_2.svg";
import { ReactComponent as School_2_3 } from "../../../../static/images/contents/zone-3/icons/2/school_3.svg";
import { ReactComponent as School_2_4 } from "../../../../static/images/contents/zone-3/icons/2/school_4.svg";
import { ReactComponent as School_2_5 } from "../../../../static/images/contents/zone-3/icons/2/school_5.svg";
import { ReactComponent as School_2_6 } from "../../../../static/images/contents/zone-3/icons/2/school_6.svg";
import { ReactComponent as School_2_7 } from "../../../../static/images/contents/zone-3/icons/2/school_7.svg";
import { ReactComponent as Shopping_2_1 } from "../../../../static/images/contents/zone-3/icons/2/shopping_1.svg";
import { ReactComponent as Shopping_2_2 } from "../../../../static/images/contents/zone-3/icons/2/shopping_2.svg";
import { ReactComponent as Hospital_2_1 } from "../../../../static/images/contents/zone-3/icons/2/hospital_1.svg";

import { ReactComponent as Church_32_1 } from "../../../../static/images/contents/zone-3/icons/33/church_1.svg";
import { ReactComponent as Church_32_2 } from "../../../../static/images/contents/zone-3/icons/33/church_2.svg";
import { ReactComponent as Church_32_3 } from "../../../../static/images/contents/zone-3/icons/33/church_3.svg";
import { ReactComponent as Church_32_4 } from "../../../../static/images/contents/zone-3/icons/33/church_4.svg";
import { ReactComponent as Church_32_5 } from "../../../../static/images/contents/zone-3/icons/33/church_5.svg";
import { ReactComponent as Church_32_6 } from "../../../../static/images/contents/zone-3/icons/33/church_6.svg";
import { ReactComponent as School_32_1 } from "../../../../static/images/contents/zone-3/icons/33/school_1.svg";
import { ReactComponent as School_32_2 } from "../../../../static/images/contents/zone-3/icons/33/school_2.svg";
import { ReactComponent as School_32_3 } from "../../../../static/images/contents/zone-3/icons/33/school_3.svg";
import { ReactComponent as Shopping_32_1 } from "../../../../static/images/contents/zone-3/icons/33/shopping_1.svg";
import { ReactComponent as Shopping_32_2 } from "../../../../static/images/contents/zone-3/icons/33/shopping_2.svg";

import { ReactComponent as Church_62_1 } from "../../../../static/images/contents/zone-3/icons/61/church_1.svg";
import { ReactComponent as Church_62_2 } from "../../../../static/images/contents/zone-3/icons/61/church_2.svg";
import { ReactComponent as Church_62_3 } from "../../../../static/images/contents/zone-3/icons/61/church_3.svg";
import { ReactComponent as Church_62_4 } from "../../../../static/images/contents/zone-3/icons/61/church_4.svg";
import { ReactComponent as Church_62_5 } from "../../../../static/images/contents/zone-3/icons/61/church_5.svg";
import { ReactComponent as Church_62_6 } from "../../../../static/images/contents/zone-3/icons/61/church_6.svg";
import { ReactComponent as Church_62_7 } from "../../../../static/images/contents/zone-3/icons/61/church_7.svg";
import { ReactComponent as Church_62_8 } from "../../../../static/images/contents/zone-3/icons/61/church_8.svg";
import { ReactComponent as School_62_1 } from "../../../../static/images/contents/zone-3/icons/61/school_1.svg";
import { ReactComponent as School_62_2 } from "../../../../static/images/contents/zone-3/icons/61/school_2.svg";
import { ReactComponent as School_62_3 } from "../../../../static/images/contents/zone-3/icons/61/school_3.svg";
import { ReactComponent as School_62_4 } from "../../../../static/images/contents/zone-3/icons/61/school_4.svg";
import { ReactComponent as School_62_5 } from "../../../../static/images/contents/zone-3/icons/61/school_5.svg";
import { ReactComponent as School_62_6 } from "../../../../static/images/contents/zone-3/icons/61/school_6.svg";
import { ReactComponent as Shopping_62_1 } from "../../../../static/images/contents/zone-3/icons/61/shopping_1.svg";
import { ReactComponent as Shopping_62_2 } from "../../../../static/images/contents/zone-3/icons/61/shopping_2.svg";
import { ReactComponent as Hospital_62_1 } from "../../../../static/images/contents/zone-3/icons/2/hospital_1.svg";

import { ReactComponent as Church_91_1 } from "../../../../static/images/contents/zone-3/icons/91/church_1.svg";
import { ReactComponent as Church_91_2 } from "../../../../static/images/contents/zone-3/icons/91/church_2.svg";
import { ReactComponent as Church_91_3 } from "../../../../static/images/contents/zone-3/icons/91/church_3.svg";
import { ReactComponent as Church_91_4 } from "../../../../static/images/contents/zone-3/icons/91/church_4.svg";
import { ReactComponent as Church_91_5 } from "../../../../static/images/contents/zone-3/icons/91/church_5.svg";
import { ReactComponent as Church_91_6 } from "../../../../static/images/contents/zone-3/icons/91/church_6.svg";
import { ReactComponent as Church_91_7 } from "../../../../static/images/contents/zone-3/icons/91/church_7.svg";
import { ReactComponent as Church_91_8 } from "../../../../static/images/contents/zone-3/icons/91/church_8.svg";
import { ReactComponent as School_91_1 } from "../../../../static/images/contents/zone-3/icons/91/school_1.svg";
import { ReactComponent as School_91_2 } from "../../../../static/images/contents/zone-3/icons/91/school_2.svg";
import { ReactComponent as School_91_3 } from "../../../../static/images/contents/zone-3/icons/91/school_3.svg";
import { ReactComponent as School_91_4 } from "../../../../static/images/contents/zone-3/icons/91/school_4.svg";
import { ReactComponent as School_91_5 } from "../../../../static/images/contents/zone-3/icons/91/school_5.svg";
import { ReactComponent as School_91_6 } from "../../../../static/images/contents/zone-3/icons/91/school_6.svg";
import { ReactComponent as School_91_7 } from "../../../../static/images/contents/zone-3/icons/91/school_7.svg";
import { ReactComponent as Shopping_91_1 } from "../../../../static/images/contents/zone-3/icons/91/shopping_1.svg";
import { ReactComponent as Shopping_91_2 } from "../../../../static/images/contents/zone-3/icons/91/shopping_2.svg";
import { ReactComponent as Hospital_91_1 } from "../../../../static/images/contents/zone-3/icons/2/hospital_1.svg";

export const zone3_landmarks = [
    {
        index: 2,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_2_8,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_2_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_2_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_2_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 32,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_32_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_32_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_32_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_32_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_32_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_32_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_32_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_32_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_32_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_32_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_32_2,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 62,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_62_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_62_8,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_62_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_62_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_62_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_62_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
    {
        index: 91,
        default: true,
        wrapper: (
            <>
                <SvgCustoms
                    customs={[
                        {
                            Element: Church_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Church_91_8,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_3,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_4,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_5,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_6,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: School_91_7,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Shopping_91_2,
                            className: "landmark",
                            onClick: null,
                        },
                        {
                            Element: Hospital_91_1,
                            className: "landmark",
                            onClick: null,
                        },
                    ]}
                />
            </>
        ),
    },
];
